<template>
  <div class="configuration">
    <TabsHead active-tab="configuration"></TabsHead>
    <Card>
      <Tabs v-model="name">
        <TabPane :label="$t('configuration.resource')">
          <Resources v-if="name === 0" class="tab-body"></Resources>
        </TabPane>
        <!-- <TabPane :label="$t('streams.sourceConfig')">
          <Sources v-if="name === 1" class="tab-body"></Sources>
        </TabPane> -->
        <TabPane :label="$t('configuration.connection')">
          <Connections v-if="name === 1" class="tab-body"></Connections>
        </TabPane>
        <TabPane :label="$t('configuration.schema')">
          <Schema v-if="name === 2" class="tab-body"></Schema>
        </TabPane>
        <TabPane :label="$t('configuration.fileManagement')">
          <UploadManagement v-if="name === 3" class="tab-body"></UploadManagement>
        </TabPane>
      </Tabs>
    </Card>
  </div>
</template>

<script>
import TabsHead from '@/components/TabsHead'
import Connections from './connections/Connections'
import Resources from './resource/Resources.vue'
// import Sources from './sources/Sources'
import Schema from './schema/Schema.vue'
import UploadManagement from './uploads/Upload.vue'

export default {
  name: 'Configuration',
  data() {
    return {
      name: 0,
    }
  },
  components: {
    TabsHead,
    Resources,
    Connections,
    Schema,
    UploadManagement,
  },
}
</script>

<style lang="scss">
.configuration {
  .ivu-card-body {
    padding: 0;
  }
  .tab-body {
    padding: 20px;
  }
}
</style>
